var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoading)?_c('div',[_c('sync-loader',{staticClass:"text-center",attrs:{"color":"white"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }